module.exports = __webpack_public_path__ + "static/img/marcelo-leal-k7ll1hpdhFA-unsplash_thumb.ad84c5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/marcelo-leal-k7ll1hpdhFA-unsplash_thumb.png
// module id = YNhy
// module chunks = 4